import WidgetTypeEnum from '../../../enums/widgets/WidgetTypeEnum'
import { findComponentByType } from '~/modules/WidgetsAndHooks/runtime/Maps/WidgetTypeToComponent'

class HookingFacade {
  public findWidgetComponentByType(type: WidgetTypeEnum) {
    return findComponentByType(type)
  }
}

export default new HookingFacade()
